import { useState } from 'react';
import { Card, CardMedia, Typography, Paper, Box,  Backdrop } from '@mui/material';
import { Anime } from '../types';



export default function AnimeCard({ anime }: { anime: Anime }) {
  const [hover, setHover] = useState(false);

  return (
    
      <Paper
        elevation={7}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          transition: 'transform 1s ease',
          transform: hover ? 'scale(1.07)' : 'scale(1)',
          cursor: 'pointer',
        }}
      >
        <Card sx={{ position: 'relative' }}>
          {/* blurred background + synopsis overlay */}
          <Backdrop open={hover} sx={{ position: 'absolute', zIndex: 2, backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <Box px={2} textAlign="center">
              <Typography variant="body2" color="#fff">
                {anime.synopsis?.slice(0, 150)}
                {anime.synopsis && anime.synopsis.length > 150 && '…'}
              </Typography>
            </Box>
          </Backdrop>
            <CardMedia
            component="img"
            image={anime.images.webp.image_url}
            alt={anime.title}
            sx={{
              aspectRatio: '7/10',
              objectFit: 'cover',
              filter: hover ? 'blur(2px)' : 'brightness(0.8)',
              transition: 'filter 1s ease',
            }}
          /> 
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              p: 1.5,
              background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
              color: 'white',
              zIndex: 1,
            }}
          >
            <Typography variant="h6" fontSize="1rem" noWrap sx={{ fontWeight: 'bold' }}>
              {anime.title}
            </Typography>
            <Typography variant="body2">Score: {anime.score}</Typography>
          </Box>
        </Card>
      </Paper>
    
  );
}